import React from 'react';
import { Widget } from '../types/widget';
import { WidgetCard } from './WidgetCard';

interface TableSectionProps {
    widgets: Widget[];
    onDelete: (widget: Widget) => void;
    onAskMore?: (contextQuery: string, contextData?: any) => void;
    renderWidget?: (widget: Widget, index: number) => React.ReactNode;
}

const TableSection: React.FC<TableSectionProps> = ({ 
    widgets, 
    onDelete, 
    onAskMore, 
    renderWidget 
}) => {
    if (widgets.length === 0) {
        return null;
    }

    return (
        <div>
            {/* Two-column grid for tables - responsive, wraps to next row */}
            <div className={`grid gap-6 ${
                widgets.length === 1 
                    ? 'grid-cols-1' 
                    : 'grid-cols-1 lg:grid-cols-2'
            }`}>
                {widgets.map((widget, index) => 
                    renderWidget ? (
                        renderWidget(widget, index)
                    ) : (
                        <WidgetCard
                            key={widget.id}
                            widget={widget}
                            onDelete={onDelete}
                            onAskMore={onAskMore}
                        />
                    )
                )}
            </div>
        </div>
    );
};

export default TableSection;